export default "__VITE_ASSET__DCn2XPRr__"